module.exports = __webpack_public_path__ + "img/ms-team-2023-24-1.ba3f06f.jpg";